import { z } from 'zod'

export enum BaseRbacRole {
  Viewer = 'Viewer',
  Editor = 'Editor',
  Approver = 'Approver',
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
}

export enum ZeusRbacRole {
  ZeusOperator = 'ZeusOperator',
  ZeusAuditor = 'ZeusAuditor',
  ZeusApprover = 'ZeusApprover',
  ZeusCertifier = 'ZeusCertifier',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ZeusITAdmin = 'ZeusITAdmin',
}

export const RbacRoleToDisplayNameMap: Record<BaseRbacRole | ZeusRbacRole, string> = {
  [BaseRbacRole.SuperAdmin]: 'Superadmin',
  [BaseRbacRole.Admin]: 'Admin',
  [BaseRbacRole.Approver]: 'Approver',
  [BaseRbacRole.Editor]: 'Editor',
  [BaseRbacRole.Viewer]: 'Viewer',
  [ZeusRbacRole.ZeusOperator]: 'Operator',
  [ZeusRbacRole.ZeusApprover]: 'Approver',
  [ZeusRbacRole.ZeusAuditor]: 'Auditor',
  [ZeusRbacRole.ZeusCertifier]: 'Certifier',
  [ZeusRbacRole.ZeusITAdmin]: 'IT Admin',
}

export const RbacRoleToDescriptionMap: Record<BaseRbacRole | ZeusRbacRole, string> = {
  [BaseRbacRole.SuperAdmin]:
    'Full admin access and permission across all orgs and legal entities, Superadmin settings, org creation',
  [BaseRbacRole.Admin]: 'Full admin access and permission to the org',
  [BaseRbacRole.Editor]: 'Transaction data editing and report viewing',
  [BaseRbacRole.Approver]: 'Transaction and report viewing, ERP journal entry approval permissions',
  [BaseRbacRole.Viewer]: 'Transaction and report viewing',
  [ZeusRbacRole.ZeusITAdmin]: 'Team and legal entity management',
  [ZeusRbacRole.ZeusOperator]:
    'Transaction data editing, Source syncing, Report viewing, Voucher creation',
  [ZeusRbacRole.ZeusAuditor]:
    'Transaction and Report viewing (masked blockchain details), Voucher review and audit',
  [ZeusRbacRole.ZeusApprover]:
    'Transaction and Report viewing (masked blockchain details), Voucher review and approve',
  [ZeusRbacRole.ZeusCertifier]:
    'Transaction and Report viewing (masked blockchain details), Voucher review and certify, ERP syncing',
}

export const userSchema = z.object({
  id: z.string(),
  email: z.string(),
  user_name: z.string(),
  org: z.string(),
  isTAS: z.boolean().optional(),
  photoURL: z.string().optional(),
  displayName: z.string().optional(),
  role: z.string(),
  isRootUser: z.boolean().optional(),
  permissions: z.array(z.string()),
  auth_metadata: z
    .object({
      external_id: z.string().nullish(),
      last_login_at: z.string().nullish(),
      created_at: z.string().nullish(),
      updated_at: z.string().nullish(),
    })
    .nullish(),
})

export type User = z.infer<typeof userSchema>
